// Icon replacement mapping from MUI icons to Google Material Icons
export const MUI_TO_GOOGLE_ICON_MAP = {
  // Search and Navigation
  'SearchIcon': 'search',
  'ArrowBackIosNewIcon': 'arrow_back_ios',
  'ArrowForwardIosIcon': 'arrow_forward_ios',
  'ArrowBackIcon': 'arrow_back',
  'ArrowForwardIcon': 'arrow_forward',
  'HomeIcon': 'home',
  'MenuIcon': 'menu',
  'CloseIcon': 'close',
  'ClearIcon': 'clear',
  
  // Actions
  'EditIcon': 'edit',
  'DeleteIcon': 'delete',
  'DeleteOutlineIcon': 'delete_outline',
  'AddIcon': 'add',
  'AddCircleIcon': 'add_circle',
  'SaveIcon': 'save',
  'CancelIcon': 'cancel',
  'RefreshIcon': 'refresh',
  'SyncIcon': 'sync',
  
  // Comments and Communication
  'InsertCommentRoundedIcon': 'insert_comment',
  'CommentIcon': 'comment',
  'EmailIcon': 'email',
  'PhoneIcon': 'phone',
  'MessageIcon': 'message',
  
  // Files and Attachments
  'AttachFileIcon': 'attach_file',
  'AttachmentIcon': 'attachment',
  'FolderIcon': 'folder',
  'SnippetFolderIcon': 'snippet_folder',
  'DownloadIcon': 'download',
  'FileDownloadIcon': 'file_download',
  'UploadIcon': 'upload',
  'FileUploadIcon': 'file_upload',
  
  // Status and Feedback
  'CheckIcon': 'check',
  'CheckCircleIcon': 'check_circle',
  'ErrorIcon': 'error',
  'WarningIcon': 'warning',
  'InfoIcon': 'info',
  
  // Visibility and Display
  'VisibilityIcon': 'visibility',
  'VisibilityOffIcon': 'visibility_off',
  'ExpandMoreIcon': 'expand_more',
  'ExpandLessIcon': 'expand_less',
  'KeyboardArrowDownIcon': 'keyboard_arrow_down',
  'KeyboardArrowUpIcon': 'keyboard_arrow_up',
  'KeyboardArrowLeftIcon': 'keyboard_arrow_left',
  'KeyboardArrowRightIcon': 'keyboard_arrow_right',
  
  // Lists and Data
  'ListIcon': 'list',
  'ViewListIcon': 'view_list',
  'FilterListIcon': 'filter_list',
  'MoreVertIcon': 'more_vert',
  'MoreHorizIcon': 'more_horiz',
  
  // People and Accounts
  'PersonIcon': 'person',
  'PersonAddIcon': 'person_add',
  'PeopleIcon': 'people',
  'AccountCircleIcon': 'account_circle',
  'AdminPanelSettingsIcon': 'admin_panel_settings',
  'ManageAccountsIcon': 'manage_accounts',
  
  // Business and Categories
  'BusinessIcon': 'business',
  'CategoryIcon': 'category',
  'SettingsIcon': 'settings',
  'ConfigurationIcon': 'settings',
  
  // Time and Calendar
  'HistoryIcon': 'history',
  'ScheduleIcon': 'schedule',
  'EventIcon': 'event',
  'CalendarTodayIcon': 'calendar_today',
  
  // Notifications and Alerts
  'NotificationsIcon': 'notifications',
  'NotificationImportantIcon': 'notification_important',
  
  // Help and Support
  'HelpIcon': 'help',
  'HelpOutlineIcon': 'help_outline',
  'ContactSupportIcon': 'contact_support',
  'SupportAgentIcon': 'support_agent',
  
  // Login and Authentication
  'LoginIcon': 'login',
  'LogoutIcon': 'logout',
  
  // Analytics and Data
  'AnalyticsIcon': 'analytics',
  'AssessmentIcon': 'assessment',
  'BarChartIcon': 'bar_chart',
  
  // Workflow and Process
  'WorkflowIcon': 'workflow',
  'ApprovalIcon': 'approval',
  'PendingIcon': 'pending',
} as const;

export type MUIIconName = keyof typeof MUI_TO_GOOGLE_ICON_MAP;
export type GoogleIconName = typeof MUI_TO_GOOGLE_ICON_MAP[MUIIconName];

// Helper function to get Google Material Icon name from MUI icon name
export const getGoogleIconName = (muiIconName: string): string => {
  return MUI_TO_GOOGLE_ICON_MAP[muiIconName as MUIIconName] || 'help_outline';
};

// Common icon sizes for consistency
export const ICON_SIZES = {
  small: 16,
  medium: 24,
  large: 32,
  xlarge: 48,
} as const;

// Common icon colors for consistency
export const ICON_COLORS = {
  primary: '#432568',
  secondary: '#666666',
  success: '#4caf50',
  error: '#f44336',
  warning: '#ff9800',
  info: '#2196f3',
  disabled: '#cccccc',
} as const;